export const form143Sections = [
    { value: '1068', label: '1068 - Sale of alcoholic liquor for human consumption' },
    { value: '1069', label: '1069 - Sale of tendu leaves' },
    { value: '1070', label: '1070 - Sale of timber obtained under a forest lease' },
    { value: '1071', label: '1071 - Sale of timber obtained by any mode other than a forest lease' },
    { value: '1072', label: '1072 - Sale of any other forest produce obtained under a forest lease' },
    { value: '1073', label: '1073 - Sale of Scrap' },
    { value: '1074', label: '1074 - Sale of minerals, being coal or lignite or iron ore' },
    { value: '1075', label: '1075 - Sale consideration exceeding threshold limit in case of sale of motor vehicle' },
    { value: '1076', label: '1076 - Sale consideration exceeding threshold limit in case of sale of wrist watch' },
    { value: '1077', label: '1077 - Sale consideration exceeding threshold limit in case of sale of art piece (antiques, painting, sculpture)' },
    { value: '1078', label: '1078 - Sale consideration exceeding threshold limit in case of sale of collectibles (coin, stamp)' },
    { value: '1079', label: '1079 - Sale consideration exceeding threshold limit in case of sale of yacht, rowing boat, canoe, helicopter' },
    { value: '1080', label: '1080 - Sale consideration exceeding threshold limit in case of sale of pair of sunglasses' },
    { value: '1081', label: '1081 - Sale consideration exceeding threshold limit in case of sale of bag (handbag, purse)' },
    { value: '1082', label: '1082 - Sale consideration exceeding threshold limit in case of sale of pair of shoes' },
    { value: '1083', label: '1083 - Sale consideration exceeding threshold limit in case of sale of sportswear and equipment' },
    { value: '1084', label: '1084 - Sale consideration exceeding threshold limit in case of sale of home theatre system' },
    { value: '1085', label: '1085 - Sale consideration exceeding threshold limit in case of sale of horse for race clubs / polo' },
    { value: '1086', label: '1086 - Remittance under LRS for education or medical treatment' },
    { value: '1087', label: '1087 - Remittance under LRS for purposes other than education or medical treatment' },
    { value: '1088', label: '1088 - Sale of overseas tour programme package (up to threshold limit)' },
    { value: '1089', label: '1089 - Sale of overseas tour programme package (above threshold limit)' },
    { value: '1090', label: '1090 - Use of parking lot for the purpose of business' },
    { value: '1091', label: '1091 - Use of toll plaza for the purpose of business' },
    { value: '1092', label: '1092 - Use of mine or quarry for the purpose of business' }
];

export const minorHeadCodes143 = [
    { value: '200', label: '200 - TCS payable by taxpayer' },
    { value: '400', label: '400 - TCS regular assessment (Raised by I. T. Dept.)' }
];

export const collectorTypes143 = [
    { value: 'A', label: 'Central Government' },
    { value: 'S', label: 'State Government' },
    { value: 'D', label: 'Statutory body (Central Govt.)' },
    { value: 'E', label: 'Statutory body (State Govt.)' },
    { value: 'G', label: 'Autonomous body (Central Govt.)' },
    { value: 'H', label: 'Autonomous body (State Govt.)' },
    { value: 'L', label: 'Local Authority (Central Govt.)' },
    { value: 'N', label: 'Local Authority (State Govt.)' },
    { value: 'K', label: 'Company' },
    { value: 'M', label: 'Branch / Division of Company' },
    { value: 'P', label: 'Association of Person (AOP)' },
    { value: 'T', label: 'Association of Person (Trust)' },
    { value: 'J', label: 'Artificial Juridical Person' },
    { value: 'B', label: 'Body of Individuals' },
    { value: 'Q', label: 'Individual/HUF' },
    { value: 'F', label: 'Firm' }
];

export const collecteeCodes143 = [
    { value: '01', label: '01 - Company' },
    { value: '02', label: '02 - Individual' },
    { value: '03', label: '03 - Hindu undivided family' },
    { value: '04', label: '04 - Association of Persons (AOP) (excluding all companies)' },
    { value: '05', label: '05 - Association of Persons (AOP) (consisting only companies)' },
    { value: '06', label: '06 - Co-operative society' },
    { value: '07', label: '07 - Firm' },
    { value: '08', label: '08 - Body of individuals' },
    { value: '09', label: '09 - Artificial juridical person' },
    { value: '10', label: '10 - Others' }
];

export const reasonCodes143 = [
    { value: '', label: 'None' },
    { value: 'A', label: 'A - Lower collection on account of certificate u/s 395(3)' },
    { value: 'B', label: 'B - Non-collection on account of declaration u/s 394(2)' },
    { value: 'C', label: 'C - Higher rate u/s 397(2) on account of non-furnishing of PAN' },
    { value: 'F', label: 'F - No collection on account of section 394(5) or 402(6)' },
    { value: 'K', label: 'K - No collection as per provisions of section 394(4)' },
    { value: 'Y', label: 'Y - No collection on account of receipt below threshold limit' },
    { value: 'Z', label: 'Z - No/lower collection in view of notification u/s 400(1)' }
];
